module.exports = __webpack_public_path__ + "static/media/44.086dea54.svg";